<template>
  <div>
    <autocomplete
      v-model="address"
      :get-list="getList"
      label="Адрес регистрации"
      :required-mark="field.required"
      :invalid="!!error"
      :error="error"
    />
  </div>
</template>

<script>
import Autocomplete from "@/components/controls2/Autocomplete";
import { getAddresses } from "@/utils/api/kladr";

export default {
  components: { Autocomplete },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      address: "",
    };
  },

  watch: {
    address() {
      this.updateValue();
    },
    matches() {
      this.updateValue();
    },

    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    async getList(query) {
      const token = this.$store.getters.getAuthToken;
      const list = await getAddresses(query, token);
      return list.map((item) => ({ id: item.id, text: item.value }));
    },
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { address } = value.value || {};
      this.address = address || "";
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      this.$emit("input", {
        value: {
          address: this.address,
        },
      });
      if (this.inited) this.$emit("change");
    },
  },
};
</script>
